export default __webpack_public_path__ + "static/media/CZ.c23d0ce4.svg";